import {useLocation} from 'react-router-dom';

import {getAccessToken} from 'infra/http/utils';
import {SelectionFlowEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {useSelectedBeneficiaryStore} from '../../store/useSelectedBeneficiaryStore';
import {useSelectedPlanStore} from '../../store/useSelectedPlanStore';
import {StepProps} from './types';

const {planSelection, beneficiarySelection, confirmSelection} =
	translations['pt-br'].others.selectionFlow;

const {changePlan, changeBeneficiary} = translations['pt-br'].commons;

export function useSteps() {
	const selectedBeneficiary = useSelectedBeneficiaryStore(state => state.selectedBeneficiary);
	const accessToken = getAccessToken();
	const selectedPlan = useSelectedPlanStore(state => state.selectedPlan);
	const {pathname} = useLocation();

	const stepsObject: Record<SelectionFlowEnum, StepProps> = {
		[SelectionFlowEnum.PLAN_SELECTION]: {
			stepNumber: 1,
			title: planSelection.title,
			subtitle: planSelection.subtitle,
			selectedItemLabel: selectedPlan?.nmPlano,
			label: planSelection.label,
			buttonLabel: changePlan,
		},
		[SelectionFlowEnum.BENEFICIARY_SELECTION]: {
			stepNumber: 2,
			title: beneficiarySelection.title,
			subtitle: beneficiarySelection.subtitle,
			selectedItemLabel:
				selectedBeneficiary?.nmSocialUsuarioC || selectedBeneficiary?.nmUsuarioC,
			label: beneficiarySelection.label,
			buttonLabel: changeBeneficiary,
		},
		[SelectionFlowEnum.CONFIRM_SELECTION]: {
			stepNumber: 3,
			title: confirmSelection.title,
			label: confirmSelection.label,
		},
	};

	const isFirstAccess = !accessToken;

	const currentStep = stepsObject[pathname as SelectionFlowEnum];
	const steps = Object.values(stepsObject);

	if (!isFirstAccess) steps.pop();
	const totalSteps = steps.length;

	return {
		isFirstAccess,
		currentStep,
		totalSteps,
		steps,
	};
}
